export const scrollToTop = () => {
  const overflowViewport = document.querySelector('[data-overflow-viewport]');
  if (overflowViewport) {
    overflowViewport.scrollTop = 0;
    return;
  }

  const main = document.querySelector('main');
  if (main) {
    main.scrollTop = 0;
    return;
  }
};
